import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./PaymentCancelModal.module.scss";

interface PaymentCancelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const PaymentCancelModal: React.FC<PaymentCancelModalProps> = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;
  
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <p className={styles.message}>{t("paymentCancelModal.confirmMessage")}</p>
        <div className={styles.buttonContainer}>
          <button 
            className={styles.cancelButton}
            onClick={onClose}
          >
            {t("paymentCancelModal.close")}
          </button>
          <button 
            className={styles.confirmButton}
            onClick={onConfirm}
          >
            {t("paymentCancelModal.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelModal;
